import { Typography, Box, useMediaQuery, Grid, Tabs, Tab } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { useIntl } from "react-intl";
import SimpleButton from "components/SimpleButton";
import "./styles.css";
import I18nKey from "translations/I18nKey";
import TrialMessage from "./components/TrialMessage";
import { TourContext } from "contexts/TourContext";
import ToCollapseBackground from "assets/Icons/ToCollapseBackground.svg";
import ToExpandBackground from "assets/Icons/ToExpandBackground.svg";
import CatalogHealth from "assets/Icons/CatalogHealth.svg";
import ToLeftArrow from "assets/Icons/ToLeftArrow.svg";
import BusinessGrowthIcon from "assets/Icons/BusinessGrowthIcon.svg";
import ConnectAccountIcon from "assets/Icons/ConnectAccountIcon.svg";
import SupplyChainIcon from "assets/Icons/SupplyChainIcon.svg";
import CloseIcon from "@mui/icons-material/Close";
import {
  AccordionStyles,
  GridContainerStyles,
  closeBtn,
  guideInfo,
  guideSubtitle,
  guideTitle,
  guideTitleText,
  iconStyles,
  optionStyles,
} from "pages/Dashboard/styles";
import { Languages, TourSteps } from "types";
import { AccordionBox } from "components/Accordion";
import { LanguageContext } from "contexts/LanguageContext";
import classNames from "classnames";
import useLoginSignupStyles from "./styles";
import { ProductsModal } from "./ProductsModal";
import { WeChatModal } from "./WeChatModal";
import { SignUpModal } from "./SignUpModal";
import DialogBox from "components/DialogBox";
import { ConfirmVerifyonLogin } from "./ConfirmVerifyonLogin";
import { SignUpConfirmMobile } from "./SignUpConfirmMobile";
import { AlertPopupMobile } from "components/AlertPopupMobile";
import { apiClient } from "api";
import { addToken } from "store/auth/auth.slice";
import { changeValue } from "store/SellerOnboarding/sellerOnboarding.slice";
import { ROUTES } from "router/types";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

const Login = () => {
  const intl = useIntl();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [inputFocus, setInputFocus] = useState<boolean>(false);
  const [openTourGuide, setOpenTourGuide] = useState<boolean>(false);
  const [openWeChatModal, setOpenWeChatModal] = useState<boolean>(false);
  const [signupLoading, setSignupLoading] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [showVerifyAcc, setShowVerifyAcc] = useState<boolean>(false);
  const [isOTPSend, setIsOTPSend] = useState<boolean>(false);
  const [usernameInput, setUserNameInput] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [err, setErr] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const classes = useLoginSignupStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    openProductsModal,
    setOpenProductsModal,
    handleOpenSignUpModal,
    showSignUpModal,
    handleTourOpen,
    handleTourStepsChange,
  } = useContext(TourContext);
  const { appLocale, setAppLocale } = useContext(LanguageContext);

  const [tabValue, setTabValue] = useState<number>(
    appLocale === Languages.CHINESE ? 2 : 1
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleTabChange = (id: number) => {
    setTabValue(id);
    if (id === 1) {
      setAppLocale(Languages.ENGLISH);
    } else {
      setAppLocale(Languages.CHINESE);
    }
  };

  const handleTourGuideClose = () => {
    setOpenTourGuide(false);
  };

  const handleInputFocus = () => {
    setInputFocus(!inputFocus);
    setOpenTourGuide(true);
  };

  const handleModalClose = () => {
    handleOpenSignUpModal(false);
  };

  const handleSignIn = async (userName: string, pwd: string) => {
    setLoading(true);
    await apiClient
      .userLogin(userName, pwd)
      .then((res: any) => {
        if (res?.data?.data) {
          let accessToken = res.data.data.access_token;
          dispatch(addToken(accessToken));
          setAlertMsg(
            intl.formatMessage({
              id: I18nKey.SIGNIN_SUCCESS,
            })
          );
          dispatch(changeValue(1));
          navigate(ROUTES.Sellers);
          setErr("");
        } else if (res.config.data.data.errors) {
          setAlertMsg(res.config.data.data.errors);
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertMsg(err.response?.data?.errors);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCloseLoginModal = () => {
    setShowVerifyAcc(false);
    setIsOTPSend(false);
  };
  return (
    <>
      <Box
        className={classNames(classes.loginTrialContainer, {
          mobile: isMobile,
        })}
      >
        <Box
          className={classNames(classes.guideTrialContainer, {
            mobile: isMobile,
          })}
        >
          <Box className={classNames(classes.tourGuideImageStyle)}>
            {!isMobile && (
              <img
                className={classNames(classes.tourGuideImage, {
                  bounceEffect: !openTourGuide,
                })}
                src={openTourGuide ? ToCollapseBackground : ToExpandBackground}
                onClick={() => setOpenTourGuide(!openTourGuide)}
              />
            )}
          </Box>

          <TrialMessage handleInputFocus={handleInputFocus} value={tabValue} />
        </Box>
      </Box>
      {openTourGuide && !isMobile && (
        <AccordionBox
          isExpanded={openTourGuide}
          isBackDrop
          styles={AccordionStyles}
          handleAccordionChange={handleTourGuideClose}
          details={
            <>
              <span style={closeBtn} onClick={handleTourGuideClose}>
                <CloseIcon />
              </span>
              <Tabs
                value={tabValue}
                className={classes.TabsStyle}
                TabIndicatorProps={{
                  hidden: true,
                }}
              >
                <Tab
                  label={intl.formatMessage({
                    id: I18nKey.ENGLISH,
                  })}
                  onClick={() => handleTabChange(1)}
                  disableRipple
                  key={2}
                  value={2}
                  className={classNames(classes.TabStyle, {
                    selectedTabStyle: tabValue === 1,
                    defaultTabStyle: tabValue === 2,
                  })}
                />
                <Tab
                  label={intl.formatMessage({
                    id: I18nKey.CHINESE,
                  })}
                  disableRipple
                  onClick={() => handleTabChange(2)}
                  key={3}
                  value={3}
                  className={classNames(classes.TabStyle, {
                    defaultTabStyle: tabValue === 1,
                    selectedTabStyle: tabValue === 2,
                    lastSelectedTabStyle: tabValue === 2,
                  })}
                />
              </Tabs>
              <Typography style={guideTitle}>
                {intl.formatMessage({
                  id: I18nKey.TOUR_GUIDETITLE,
                })}
                {/* 
                HIGHLIGHTED PART IN TOUR GUIDE  TITLE
                <span style={guideTitleText}>
                  {intl.formatMessage({
                    id: I18nKey.TOUR_ONETOOL,
                  })}
                </span> */}
              </Typography>
              <Typography style={guideInfo}>
                {intl.formatMessage({
                  id: I18nKey.TOUR_GUIDEINFO,
                })}
              </Typography>
              <Typography style={guideSubtitle}>
                {intl.formatMessage({
                  id: I18nKey.TOUR_GUIDESUBTITLE,
                })}
              </Typography>
              <Grid
                container
                rowSpacing={1}
                sx={{
                  ...GridContainerStyles,
                }}
              >
                <Grid item xs={12}>
                  <Box
                    sx={{ ...optionStyles }}
                    onClick={() => {
                      handleTourGuideClose();
                      handleTourStepsChange(TourSteps.CATALOG);
                      handleTourOpen(0);
                    }}
                  >
                    <img src={ToLeftArrow} className="leftArrow" />
                    <img src={CatalogHealth} style={{ ...iconStyles }} />
                    {intl.formatMessage({
                      id: I18nKey.TOUR_BOX_HEALTH,
                    })}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{ ...optionStyles }}
                    onClick={() => {
                      handleTourGuideClose();
                      handleTourStepsChange(TourSteps.SUPPLY_CHAIN);
                      handleTourOpen(0);
                    }}
                  >
                    <img src={ToLeftArrow} className="leftArrow" />
                    <img src={BusinessGrowthIcon} style={{ ...iconStyles }} />
                    {intl.formatMessage({
                      id: I18nKey.TOUR_BOX_SUPPLYCHAIN,
                    })}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{ ...optionStyles }}
                    onClick={() => {
                      handleTourGuideClose();
                      handleTourStepsChange(TourSteps.BUSINESS);
                      handleTourOpen(0);
                    }}
                  >
                    <img src={ToLeftArrow} className="leftArrow" />
                    <img src={ConnectAccountIcon} style={{ ...iconStyles }} />
                    {intl.formatMessage({
                      id: I18nKey.TOUR_BOX_BUSINESS,
                    })}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{ ...optionStyles }}
                    onClick={() => {
                      handleTourGuideClose();
                      handleOpenSignUpModal(true);
                      handleTourStepsChange(TourSteps.SELLER_ACCOUNT);
                      handleTourOpen(0);
                    }}
                  >
                    <img src={ToLeftArrow} className="leftArrow" />
                    <img src={SupplyChainIcon} style={{ ...iconStyles }} />
                    {intl.formatMessage({
                      id: I18nKey.TOUR_BOX_SELLERACC,
                    })}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    className={classes.viewPricingBtn}
                    onClick={() => setOpenWeChatModal(true)}
                  >
                    {intl.formatMessage({
                      id: I18nKey.CHAT_LIVE,
                    })}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    className={classes.viewPricingBtn}
                    onClick={() => setOpenProductsModal(true)}
                  >
                    {intl.formatMessage({
                      id: I18nKey.TOUR_VIEW_PRICING,
                    })}
                  </Box>
                </Grid>
              </Grid>
              <Box
                className={classNames(classes.signupExitContainer, {
                  mobile: isMobile,
                })}
              >
                <SimpleButton
                  primary
                  text={intl.formatMessage({
                    id: I18nKey.SIGNUP,
                  })}
                  onClick={() => handleOpenSignUpModal(true)}
                  className={classes.signUpTour}
                  loading={false}
                />
                <SimpleButton
                  text={intl.formatMessage({
                    id: I18nKey.EXIT_GUIDE,
                  })}
                  onClick={() => setOpenTourGuide(false)}
                  className={classes.exitGuide}
                  loading={false}
                />
              </Box>
            </>
          }
        ></AccordionBox>
      )}
      {showSignUpModal && (
        <SignUpModal
          isModalOpen={showSignUpModal}
          handleModalClose={handleModalClose}
          setSignupLoading={setSignupLoading}
          signupLoading={signupLoading}
          inputFocus={inputFocus}
          setIsSuccess={setIsSuccess}
          setAlertMsg={setAlertMsg}
          handleSignIn={handleSignIn}
        />
      )}
      {showVerifyAcc && (
        <DialogBox
          isModalOpen={showVerifyAcc}
          handleModalClose={handleCloseLoginModal}
          content={
            !isOTPSend ? (
              <ConfirmVerifyonLogin
                userName={usernameInput}
                setConfirmUserName={setUserName}
                setIsOTPSend={setIsOTPSend}
              />
            ) : (
              <SignUpConfirmMobile
                userName={userName}
                password={password}
                handleModalClose={handleModalClose}
                setIsSuccess={setIsSuccess}
                setSignupLoading={setSignupLoading}
                handleSignIn={handleSignIn}
                setAlertMsg={setAlertMsg}
              />
            )
          }
        ></DialogBox>
      )}

      {err && isMobile ? (
        <AlertPopupMobile
          loading={isLoading}
          isSuccess={isSuccess}
          alertMsg={err}
          className={classNames(classes.alertPopupMobile, {
            mobile: isMobile,
          })}
        />
      ) : null}
      <ProductsModal openProductsModal={openProductsModal} />
      <WeChatModal
        openWeChatModal={openWeChatModal}
        setOpenWeChatModal={setOpenWeChatModal}
      />
    </>
  );
};

export default Login;
